import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { ProductOutputDTO, Product } from './productDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class ProductServices {
  async getByAll(params = {}): Promise<ProductOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product/`, {
        headers: { 'authentication-token': getJWT()! },
        params: {
          limit: 999,
          ...params,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByWorkUnit(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-by-work-unit/joined/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductByWorkUnitId(id: number, is_offline = false): Promise<Product[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/product-by-work-unit/work-unit/${id}`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: is_offline ? { filter_by_is_offline: is_offline } : {},
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductByWorkUnitIds(queryParamsString?: string): Promise<Product[]> {
    try {
      let url = `${process.env.REACT_APP_URL_RESERVATION}/product-by-work-unit/work-units/`
      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }
      const res = await axios.get(url, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductByWorkUnitWithId(id: number): Promise<Product[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-by-work-unit/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductByWorkUnitToken(token: string): Promise<Product[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/product-by-work-unit/token/${token}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllProductTypes(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-type/`, {
        headers: { 'authentication-token': getJWT()! },
        params: {
          limit: 999,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
  async getDetailsTable(): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product/schemas/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getSkeletonTable(entity_name: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/product/schemas/map/?entity_name=${entity_name}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteProductByWorkUnit(product: any): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/product-by-work-unit/${product?.id}`,
        {
          headers: { 'authentication-token': getJWT()! },
          data: product,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteProductByWorkUnitByBusinessUnit(product: any): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/product-work-unit-by-business-unit/${product?.id}`,
        {
          headers: { 'authentication-token': getJWT()! },
          data: product,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductByBusinessUnitId(id: number, is_offline = false): Promise<Product[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-unit/products/${id}`, {
        headers: { 'authentication-token': getJWT()! },
        params: is_offline ? { filter_by_is_offline: is_offline } : {},
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const productServices = new ProductServices()
